import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "map_search",
  "use": "map_search-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" preserveAspectRatio=\"xMidYMid\" viewBox=\"0 0 18 18\" id=\"map_search\"><path d=\"M12.268 7.381c0 2.678-2.192 4.856-4.887 4.856-2.696 0-4.906-2.178-4.906-4.856 0-2.696 2.192-4.877 4.906-4.877 2.695 0 4.887 2.199 4.887 4.877Zm1.148 4.124a7.282 7.282 0 0 0 1.272-4.124c0-4.035-3.246-7.369-7.307-7.369C3.319.012 0 3.346 0 7.381s3.319 7.293 7.381 7.293a7.563 7.563 0 0 0 4.169-1.281l4.539 4.615L18 16.084l-4.584-4.579Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol